import { useState } from "react";
import { Box } from "@mui/material";

import { Service } from "../../../types/service.type";

import RequestSubmittedModal from "../../../components/RequestSubmittedModal";
import { GoHireHeader, GoHireHeaderLoader } from "../../../components/GoHireHeader";

import { ProgramVideos, ProgramVideosLoader } from "./ProgramVideos";
import { ProgramReviews, ProgramReviewsEmpty } from "./ProgramReviews";
import { ProgramSummary, ProgramSummaryLoader } from "./ProgramSummary";
import { ProviderDetails, ProviderDetailsLoader } from "./ProviderDetails";
import { ProgramEquipments, ProgramEquipmentsLoader } from "./ProgramEquipments";
import { ProgramDescription, ProgramDescriptionLoader } from "./ProgramDescription";

export const UnBoughtProgram = ({ service }: { service: Service }) => {
  const [isRequestSubmittedModalOpen, setIsRequestSubmittedModalOpen] = useState(false);

  const handleRequestSubmittedModal = () => setIsRequestSubmittedModalOpen(true);
  const handleCloseRequestSubmittedModal = () => setIsRequestSubmittedModalOpen(false);

  return (
    <>
      <Box sx={styles.container}>
        <Box sx={styles.contentContainer}>
          <GoHireHeader service={service} handleRequestSubmittedModal={handleRequestSubmittedModal} />
          <Box sx={styles.programDetailsContainer}>
            <ProgramDescription service={service} />
            <ProgramEquipments service={service} />
            <ProgramVideos service={service} />
            <ProviderDetails service={service} />
            <ProgramReviews service={service} />
          </Box>
        </Box>
        <ProgramSummary programService={service} />
      </Box>
      <RequestSubmittedModal open={isRequestSubmittedModalOpen} closeModal={handleCloseRequestSubmittedModal} />
    </>
  );
};

export default UnBoughtProgram;

export const UnBoughtProgramLoader = () => {
  return (
    <Box sx={styles.container}>
      <Box sx={styles.contentContainer}>
        <GoHireHeaderLoader />
        <Box sx={styles.programDetailsContainer}>
          <ProgramDescriptionLoader />
          <ProgramEquipmentsLoader />
          <ProgramVideosLoader />
          <ProviderDetailsLoader />
          <ProgramReviewsEmpty />
        </Box>
      </Box>
      <ProgramSummaryLoader />
    </Box>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: { xs: "column", lg: "row" },
    gap: "10px",
    width: "100%",
  },
  contentContainer: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    justifyContent: "space-between",
    width: { xs: "100%", lg: "553px" },
  },
  programDetailsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
};
